export type QuickFilterItem = {
  label: string;
  type: string;
  color: string;
  list: {
    label: string;
    type: string;
    value: string;
    tooltip?: string;
    selected?: boolean;
    count?: number; // 新增count字段
  }[];
};

//性别
export const Gender = [
  //女
  { label: '女', value: 'FEMALE', color: '#F56C6C' },
  //男
  { label: '男', value: 'MALE', color: '#409EFF' },
];

//快捷筛选
export enum QuickFilter {
  //今日分配线索
  TODAY_UNASSIGNED = 'todayUnassigned',
  //今日试课未跟进
  TODAY_UNFOLLOW = 'todayUnfollow',
  //本周未发券
  WEEKLY_UNASSIGNED_COUPON = 'weeklyUnassignedCoupon',
  //本周发券未试课
  WEEKLY_UNASSIGNED = 'weeklyUnassigned',
  //本周约课未试课
  WEEKLY_UNFOLLOW = 'weeklyUnfollow',
  //本周试课未成交
  WEEKLY_UNDEAL = 'weeklyUndeal',
}

// 快捷筛选模块类型
export enum QuickFilterType {
  QUICK_FILTER = 'quickFilter',
  ASSIGN = 'assign',
  TODAY = 'today',
  WEEKLY = 'weekly',
}

// 快捷筛选项的类型
export enum FilterItemType {
  //今日分配线索
  TODAY_UNASSIGNED = 'todayUnassigned',
  //今日试课未跟进
  TODAY_UNFOLLOW = 'todayUnfollow',
  //本周未发券
  WEEKLY_UNASSIGNED_COUPON = 'sevenDaysUnassigned',
  //本周发券未试课
  WEEKLY_UNASSIGNED = 'weeklyUnassigned',
  //本周约课未试课
  WEEKLY_UNFOLLOW = 'weeklyUnfollow',
  //本周试课未成交
  WEEKLY_UNDEAL = 'weeklyUndeal',
}

// 快捷筛选
export function getQuickFilterOptions() {
  return [
    {
      label: '快捷筛选', // 合并为一个标题
      type: QuickFilterType.QUICK_FILTER,
      color: 'green',
      list: [
        // 今日状态组
        {
          label: '今日分配线索',
          count: 0,
          type: FilterItemType.TODAY_UNASSIGNED,
          value: QuickFilter.TODAY_UNASSIGNED,
        },
        {
          label: '今日试课未跟进',
          count: 0,
          type: FilterItemType.TODAY_UNFOLLOW,
          value: QuickFilter.TODAY_UNFOLLOW,
        },
        // 本周状态组
        {
          label: '本周未发券',
          count: 0,
          type: FilterItemType.WEEKLY_UNASSIGNED_COUPON,
          value: QuickFilter.WEEKLY_UNASSIGNED_COUPON,
        },
        {
          label: '本周发券未约课',
          count: 0,
          type: FilterItemType.WEEKLY_UNASSIGNED,
          value: QuickFilter.WEEKLY_UNASSIGNED,
        },
        {
          label: '本周约课未试课',
          count: 0,
          type: FilterItemType.WEEKLY_UNFOLLOW,
          value: QuickFilter.WEEKLY_UNFOLLOW,
        },
        {
          label: '本周试课未成交',
          count: 0,
          type: FilterItemType.WEEKLY_UNDEAL,
          value: QuickFilter.WEEKLY_UNDEAL,
        },
      ],
    },
  ];
}
